// Page-wide behaviour: delegated HTML5 drop targets (data-dws-dropzone), the iOS click enabler and the scroll
// state of DwsPageBaseComponent's scroller (data-dws-scrolling on .dws-basepage-frame).

// HTML5 drop targets: a drop only fires on an element whose dragover was cancelled, and Blazor's
// @ondragover:preventDefault cancels nothing unless some element on the page also has a .NET @ondragover
// handler (Blazor only listens for event types it has handlers for). Components mark their drop targets with
// data-dws-dropzone="true" instead, and this one delegated listener cancels dragover for them without a
// round trip per tick (nav links and groups, DataGrid rows and headers, Treeview and TreeTable strips, toasts).
const dwsDropZones = {
    _onDragOver: function (e: DragEvent): void {
        const target = e.target;
        const zone = target instanceof Element ? target.closest("[data-dws-dropzone='true']") : null;

        if (zone) {
            e.preventDefault();

            if (e.dataTransfer) {
                e.dataTransfer.dropEffect = "move";
            }
        }
    }
};

document.addEventListener("dragover", dwsDropZones._onDragOver);

// iOS Safari (WebKit) only sends a click for a tap on a non-interactive element (a div option, a calendar cell, a row)
// when that element or an ancestor below the document has a click listener of its own. Blazor delegates every @onclick
// from the document, so such taps produced no click at all: an AutoComplete option could not be picked by touch. A
// no-op listener on <body> makes every element "clickable" for WebKit without changing any behaviour.
(function () {
    function noop() { }

    if (document.body) {
        document.body.addEventListener("click", noop);
    } else {
        document.addEventListener("DOMContentLoaded", function () {
            document.body.addEventListener("click", noop);
        });
    }
})();

// DwsPageBaseComponent: marks a page's frame with data-dws-scrolling while its .basepage scrolls, and for a moment after.
// On phones the anchor handles fade out meanwhile (Styles/components/_pagesidewindow.scss), so they do not ride over the
// text going by. One capturing listener for every page (scroll does not bubble, capture still sees it); no interop.
const dwsBasePageScroll = {
    idleMs: 700,
    timers: typeof WeakMap === "function" ? new WeakMap() : null,

    onScroll: function (e) {
        const self = dwsBasePageScroll;
        const page = e.target;

        if (!self.timers || !page || page.nodeType !== 1 || !page.classList.contains("basepage")) {
            return;
        }

        const frame = page.parentElement;

        if (!frame || !frame.classList.contains("dws-basepage-frame")) {
            return;
        }

        if (!frame.hasAttribute("data-dws-scrolling")) {
            frame.setAttribute("data-dws-scrolling", "");
        }

        const pending = self.timers.get(frame);

        if (pending) {
            clearTimeout(pending);
        }

        self.timers.set(frame, setTimeout(function () {
            self.timers.delete(frame);
            frame.removeAttribute("data-dws-scrolling");
        }, self.idleMs));
    }
};

document.addEventListener("scroll", dwsBasePageScroll.onScroll, { capture: true, passive: true });
